
  (function() {
  // Esperar a que el DOM esté completamente cargado
  document.addEventListener('DOMContentLoaded', function() {
    // Seleccionar todos los selectores de idioma en la página
    const languageSelectors = document.querySelectorAll('[data-language-selector]');
    
    languageSelectors.forEach(wrapper => {
      const originalSelect = wrapper.querySelector('[data-original-select]');
      const customTrigger = wrapper.querySelector('[data-custom-trigger]');
      const customDropdown = wrapper.querySelector('[data-custom-dropdown]');
      const customValue = wrapper.querySelector('[data-custom-value]');
      const customOptions = wrapper.querySelectorAll('[data-value]');
      
      let isOpen = false;
      
      // Función para cerrar todos los dropdowns
      function closeAllDropdowns() {
        document.querySelectorAll('[data-custom-dropdown]').forEach(dropdown => {
          dropdown.setAttribute('hidden', '');
          const parentSelect = dropdown.closest('.custom-select');
          if (parentSelect) {
            parentSelect.classList.remove('open');
          }
        });
      }
      
      // Función para abrir el dropdown
      function openDropdown() {
        closeAllDropdowns(); // Cierra otros dropdowns
        customDropdown.removeAttribute('hidden');
        customTrigger.closest('.custom-select')?.classList.add('open');
        isOpen = true;
      }
      
      // Función para cerrar el dropdown
      function closeDropdown() {
        customDropdown.setAttribute('hidden', '');
        customTrigger.closest('.custom-select')?.classList.remove('open');
        isOpen = false;
      }
      
      // Toggle dropdown
      function toggleDropdown(event) {
        event.stopPropagation();
        if (isOpen) {
          closeDropdown();
        } else {
          openDropdown();
        }
      }
      
      // Actualizar el valor seleccionado
      function updateSelectedValue(value, fullName) {
        // Actualizar el texto del trigger (solo iniciales)
        const initials = value.substring(0, 2).toUpperCase();
        customValue.textContent = initials;
        
        // Actualizar el select original
        if (originalSelect) {
          originalSelect.value = value;
          
          // Disparar evento change
          const changeEvent = new Event('change', { bubbles: true });
          originalSelect.dispatchEvent(changeEvent);
        }
        
        // Marcar la opción como seleccionada en el dropdown
        customOptions.forEach(opt => {
          const optValue = opt.dataset.value;
          if (optValue === value) {
            opt.classList.add('selected');
            opt.setAttribute('aria-selected', 'true');
          } else {
            opt.classList.remove('selected');
            opt.setAttribute('aria-selected', 'false');
          }
        });
        
        // Cerrar dropdown después de seleccionar
        closeDropdown();
      }
      
      // Verificar que todos los elementos existen
      if (!customTrigger || !customDropdown) {
        console.error('No se encontraron los elementos del custom select');
        return;
      }
      
      // Event Listeners
      customTrigger.addEventListener('click', toggleDropdown);
      
      // Opciones del dropdown
      customOptions.forEach(option => {
        option.addEventListener('click', (e) => {
          e.stopPropagation();
          const value = option.dataset.value;
          const fullName = option.dataset.fullname || value;
          updateSelectedValue(value, fullName);
        });
      });
      
      // Cerrar al hacer clic fuera
      document.addEventListener('click', (e) => {
        if (!wrapper.contains(e.target)) {
          closeDropdown();
        }
      });
      
      // Prevenir que el dropdown se cierre al hacer clic dentro de él
      customDropdown.addEventListener('click', (e) => {
        e.stopPropagation();
      });
      
      // Inicializar el valor mostrado
      if (originalSelect && customValue) {
        const initialValue = originalSelect.value;
        customValue.textContent = initialValue.substring(0, 2).toUpperCase();
      }
      
      // Sincronizar con cambios externos
      if (originalSelect) {
        originalSelect.addEventListener('change', (e) => {
          const newValue = e.target.value;
          customValue.textContent = newValue.substring(0, 2).toUpperCase();
          
          customOptions.forEach(opt => {
            if (opt.dataset.value === newValue) {
              opt.classList.add('selected');
            } else {
              opt.classList.remove('selected');
            }
          });
        });
      }
    });
  });
})();